import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getMaintenanceCompanyList,
	addNewMaintenanceCompany,
	updateMaintenanceCompany,
	deleteMaintenanceCompany,
	getMaintenanceCompany,
} from '../maintenanceCompany/thunk';

export const initialState = {
	itemMaintenanceCompanyList: [],
	itemMaintenanceCompanyDetail: null,
	isMaintenanceCompanyLoading: false,
	isMaintenanceCompanySuccess: false,

	holdingList: [],
	holdingListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const MaintenanceCompanySlice = createSlice({
	name: 'MaintenanceCompany',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getMaintenanceCompany.fulfilled, (state, action) => {
			state.isMaintenanceCompanyLoading = false;
			state.isMaintenanceCompanySuccess = true;
			state.itemMaintenanceCompanyDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getMaintenanceCompany.pending, state => {
			state.isMaintenanceCompanyLoading = true;
			state.isMaintenanceCompanySuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getMaintenanceCompany.rejected, (state, action) => {
			state.isMaintenanceCompanyLoading = false;
			state.isMaintenanceCompanySuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getMaintenanceCompanyList.pending, state => {
			state.isMaintenanceCompanySuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getMaintenanceCompanyList.fulfilled, (state, action) => {
			state.itemMaintenanceCompanyList = action.payload;
			state.holdingList = action.payload;
			state.isLoadingList = false;
			state.isMaintenanceCompanySuccess = true;

			let holdingListSelect = [];
			action.payload.map(item =>
				holdingListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.holdingListSelect = holdingListSelect;
		});
		builder.addCase(getMaintenanceCompanyList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isMaintenanceCompanySuccess = true;
		});
		builder.addCase(addNewMaintenanceCompany.fulfilled, (state, action) => {
			state.itemMaintenanceCompanyList.push(action.payload);
			state.holdingList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewMaintenanceCompany.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewMaintenanceCompany.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateMaintenanceCompany.fulfilled, (state, action) => {
			state.itemMaintenanceCompanyList = state.itemMaintenanceCompanyList.map(holding =>
				holding.holdingname === action.payload.old_holding
					? { ...holding, ...action.payload.updated_holding }
					: holding
			);
			state.holdingList = state.holdingList.map(holding =>
				holding._id.toString() === action.payload._id.toString()
					? { ...holding, ...action.payload }
					: holding
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateMaintenanceCompany.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateMaintenanceCompany.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteMaintenanceCompany.fulfilled, (state, action) => {
			state.itemMaintenanceCompanyList = current(state.itemMaintenanceCompanyList).filter(
				item => item._id !== action.payload._id
			);
			state.holdingList = current(state.holdingList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteMaintenanceCompany.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteMaintenanceCompany.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = MaintenanceCompanySlice.actions;

export default MaintenanceCompanySlice.reducer;
